export enum StackTaskKind {
  FileRestore = "FileRestore",
  FileTranscode = "FileTranscode",
  FileCopyOrDeliver = "FileCopyOrDeliver",
  MetadataExport = "MetadataExport",
  HumanTask = "HumanTask",
  ErpConnect = "ErpConnect",
  FileArchive = "FileArchive",
  Legacy = "Legacy",
}
